import cssVars from 'css-vars-ponyfill';
import imagesLoaded from 'imagesloaded';
import { setMenuOffset } from './menuOffset.js';

const app = document.querySelector('#app');

document.addEventListener('DOMContentLoaded', () => setMenuOffset());

const loadPage = () => {
	// Polyfill CSS Vars
	// CSS Variable Polyfill
	cssVars({
		include: 'link[rel=stylesheet],style',
		onlyLegacy: true,
	});

	// Fade page load
	if (document.body.classList.contains('preload')) {
		document.body.classList.remove('preload');
		document.body.classList.add('loaded-dom');
	}
};

imagesLoaded(app).on('always', loadPage);
